import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';

export const calculationAPI = createApi({
  reducerPath: 'calculationAPI',
  baseQuery: customBaseQuery,
  tagTypes: ['CalculationData', 'ExchangeRates'],
  endpoints: (builder) => ({
    getCalculationData: builder.query<
      any,
      { assessmentType: string; assessmentId: string }
    >({
      query: ({ assessmentType, assessmentId }) =>
        `/calculations/${assessmentId}/${assessmentType}`,
      providesTags: ['CalculationData'],
    }),
    upsertAssessmentCalculation: builder.mutation<
      ApiResponse<any>,
      {
        data: any;
        assessmentType: string;
        sourceAssessmentId: string;
      }
    >({
      query: ({ data, assessmentType, sourceAssessmentId }) => ({
        url: `/calculations/${assessmentType}/${sourceAssessmentId}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['CalculationData'],
    }),
    getExchangeRates: builder.query<
      ApiResponse<{
        applicant?: ExchangeRatePayload;
        coapplicant?: ExchangeRatePayload;
      }>,
      { calculationId: string; assessmentType: string }
    >({
      query: ({ calculationId, assessmentType }) =>
        `/calculations/${calculationId}/${assessmentType}/exchange-rates`,
      providesTags: ['ExchangeRates'],
    }),
    upsertExchangeRates: builder.mutation<
      ApiResponse<any>,
      {
        calculationId: string;
        assessmentType: string;
        applicant: ExchangeRatePayload;
        coapplicant?: ExchangeRatePayload;
      }
    >({
      query: ({ calculationId, assessmentType, applicant, coapplicant }) => ({
        url: `/calculations/${calculationId}/${assessmentType}/exchange-rates`,
        method: 'POST',
        body: { applicant, ...(coapplicant ? { coapplicant } : {}) },
      }),
      invalidatesTags: ['ExchangeRates'],
    }),
    getCalculationDataByAssessmentId: builder.query<
      any,
      { assessmentId: string }
    >({
      query: ({ assessmentId }) => `/calculations/${assessmentId}`,
      providesTags: ['CalculationData'],
    }),
    upsertCalculationByAssessmentId: builder.mutation<
      ApiResponse<any>,
      { assessmentId: string; data: object }
    >({
      query: ({ assessmentId, data }) => ({
        url: `/calculations/${assessmentId}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['CalculationData'],
    }),
  }),
});

export interface ExchangeRatePayload {
  email: string;
  from: string;
  to: string;
  rate: number;
  setAt: string;
}

export const {
  useGetCalculationDataQuery,
  useUpsertAssessmentCalculationMutation,
  useGetExchangeRatesQuery,
  useUpsertExchangeRatesMutation,
  useGetCalculationDataByAssessmentIdQuery,
  useUpsertCalculationByAssessmentIdMutation,
} = calculationAPI;
